<div class="login-modal">
  <div class="icon-close" (click)="closeModal()">
    <i class="icon-X"></i>
  </div>
  <h3 class="login-title">{{ 'Login'|translate }}</h3>
  <div [hidden]="!firstLogin" class="first-login">
    <form>
      <app-input
        class="mb-24"
        [placeholder]="'Enter email'|translate"
        type="email"
        [title]="'Email' | translate"
        [formControl]="firstEmail"
        [pattern]="EMAIL_INPUT_REGEX"
        [pastePattern]="PASTE_EMAIL_REGEX"
        [isSubmitRequired]="true"
        [isSubmitted]="isEmailSubmitted"
      ></app-input>
      <div class="login-btn">
        <app-button
          type="submit"
          ariaLabel="Continue"
          [buttonStyleType]="ButtonTypes.PRIMARY_0"
          [disabled]="!firstEmail.value?.length"
          [buttonSize]="BUTTON_SIZE.FULL_SIZE"
          (clicked)="onSubmitEmail($event)"
        >{{ 'Continue'|translate }}
        </app-button>
      </div>
    </form>

  </div>

  @if (!firstLogin) {
    <form [formGroup]="loginForm" class="login-form">
      <app-input
        class="mb-24"
        [placeholder]="'Enter email'|translate"
        type="email"
        [title]="'Email' | translate"
        formControlName="email"
        [pattern]="EMAIL_INPUT_REGEX"
        [pastePattern]="PASTE_EMAIL_REGEX"
        (keyup.enter)="onSignIn()"
        [isSubmitRequired]="true"
        [isSubmitted]="isFormSubmitted"
      ></app-input>
      <app-input
        class="mb-24"
        [title]="'Password'|translate"
        type="password"
        [placeholder]="'Enter password'|translate"
        formControlName="password"
        (keyup.enter)="$event.preventDefault();"
        [isSubmitRequired]="true"
        [isSubmitted]="isFormSubmitted"
      ></app-input>
      <div class="forgot-btn">
        <app-button
          type="button"
          [ariaLabel]="'Forgot password'|translate "
          [buttonStyleType]="ButtonTypes.TEXT_0"
          (clicked)="onForgotPassword()"
        >{{ 'Forgot password'|translate }}?
        </app-button>
      </div>
      <div class="login-btn">
        <app-button
          type="submit"
          [ariaLabel]="'Continue'|translate"
          [buttonStyleType]="ButtonTypes.PRIMARY_0"
          [disabled]="!loginForm.value.email || !loginForm.value.password"
          [buttonSize]="BUTTON_SIZE.FULL_SIZE"
          (clicked)="onSignIn()"
        >{{ 'Continue'|translate }}
        </app-button>
      </div>
    </form>
  }
  <div class="signup-container">
    <span>{{ 'Don’t have an account'|translate }}?</span>
    <span (click)="signUp()" class="sign-up-btn">{{ 'Sign up'|translate }}</span>
  </div>
</div>
